export default __webpack_public_path__ + "static/media/vector.fd09caec.png";